import { render, staticRenderFns } from "./eventCalendar.vue?vue&type=template&id=9577c656&scoped=true"
import script from "./eventCalendar.vue?vue&type=script&lang=js"
export * from "./eventCalendar.vue?vue&type=script&lang=js"
import style0 from "./eventCalendar.vue?vue&type=style&index=0&id=9577c656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9577c656",
  null
  
)

export default component.exports